import {
  CREATED_BY_FILTER_CHANGE,
  DATE_FILTER_CHANGE,
  EVENTS_FILTER_CHANGE,
  FETCH_ACTIVITIES_ASYNC,
  FETCH_ACTIVITIES_CSV_ASYNC,
  FETCH_ALL_FILTERS_ASYNC,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SORT_PROPERTY_CHANGE,
  TARGETS_FILTER_CHANGE,
} from './constants'

export const fetchActivities = () => ({ type: FETCH_ACTIVITIES_ASYNC.INITIATE })
export const fetchActivitiesSuccess = (data) => ({
  type: FETCH_ACTIVITIES_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchActivitiesError = (error) => ({
  type: FETCH_ACTIVITIES_ASYNC.ERROR,
  error,
})
export const fetchActivitiesCancel = () => ({
  type: FETCH_ACTIVITIES_ASYNC.CANCEL,
})

export const fetchAllActivitiesFilters = () => ({
  type: FETCH_ALL_FILTERS_ASYNC.INITIATE,
})
export const fetchAllActivitiesFiltersSuccess = (data) => ({
  type: FETCH_ALL_FILTERS_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchAllActivitiesFiltersError = (error) => ({
  type: FETCH_ALL_FILTERS_ASYNC.ERROR,
  error,
})
export const fetchAllActivitiesFiltersCancel = () => ({
  type: FETCH_ALL_FILTERS_ASYNC.CANCEL,
})

const fetchActivitiesCSV = () => ({ type: FETCH_ACTIVITIES_CSV_ASYNC.INITIATE })
export const fetchActivitiesCSVSuccess = (data) => ({
  type: FETCH_ACTIVITIES_CSV_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchActivitiesCSVError = (error) => ({
  type: FETCH_ACTIVITIES_CSV_ASYNC.ERROR,
  error,
})
const fetchActivitiesCSVCancel = () => ({
  type: FETCH_ACTIVITIES_CSV_ASYNC.CANCEL,
})

export const targetsFilterChange = (targetsArray) => ({
  type: TARGETS_FILTER_CHANGE,
  payload: { targetsArray },
})
export const eventsTypeFilterChange = (eventsTypeArray) => ({
  type: EVENTS_FILTER_CHANGE,
  payload: { eventsTypeArray },
})
export const createdByFilterChange = (createdByArray) => ({
  type: CREATED_BY_FILTER_CHANGE,
  payload: { createdByArray },
})

const dateFilterChange = (dateFilter) => ({
  type: DATE_FILTER_CHANGE,
  payload: { dateFilter },
})
const paginateChange = (page) => ({ type: PAGINATE_CHANGE, payload: { page } })
const searchChange = (q) => ({ type: SEARCH_CHANGE, payload: { q } })
const searchReset = () => ({ type: SEARCH_RESET })

const sortPropertyChange = (value) => ({
  type: SORT_PROPERTY_CHANGE,
  payload: { value },
})

export default {
  // to props
  fetchActivitiesCSV,
  fetchActivitiesCSVCancel,
  fetchActivities,
  fetchActivitiesCancel,
  eventsTypeFilterChange,
  createdByFilterChange,
  targetsFilterChange,
  fetchAllActivitiesFilters,
  fetchAllActivitiesFiltersCancel,
  dateFilterChange,
  paginateChange,
  searchChange,
  searchReset,
  sortPropertyChange,
}
